export default __webpack_public_path__ + "static/media/pantry1-afterG-1920w.2d9d82df.avif";